import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';
import BreakdownModal from '../modals/BreakdownModal';
import ViewSOAModal from '../modals/ViewSOAModal';

function BuildingTransactionsContainer({
  transactionsList,
  applicationId,
  getTransactionList,
  isLoading,
}) {

  const setModal = useContext(ModalContext);

  const handleShowBreakdown = (data) => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BreakdownModal transactionsList={data} />,
      title: 'Transaction Breakdown',
      modalSize: 'modal-xl',
    });
  };

  const handleViewSOA = (data, id) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewSOAModal data={data} applicationId={id} />,
      title: `View e-SOA`,
      modalSize: 'modal-xl',
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getTransactionList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getTransactionList(applicationId);
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">TDN</td>
                    <td className="font-weight-bold">PIN</td>
                    <td className="font-weight-bold">QTR</td>
                    <td className="font-weight-bold">Year</td>
                    <td className="font-weight-bold">Amount Due</td>
                    <td className="font-weight-bold"> Action </td>
                  </tr>
                </thead>
                <tbody>
                  {transactionsList &&
                    transactionsList.length <= 0 && (
                      <tr className="text-center">
                        <td className="history-color" colSpan="7">No data</td>
                      </tr>
                    )}
                  {transactionsList &&
                    transactionsList.map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'included.building_application.attributes.tdn')}</td>
                        <td className="history-color">{_.get(item, 'included.building_application.attributes.pin')}</td>
                        <td className="history-color">{_.get(item, 'attributes.qtr')}</td>
                        <td className="history-color">{_.get(item, 'attributes.year')}</td>
                        <td className="history-color">{_.get(item, 'attributes.amount_due')}</td>
                        <td width="250">
                          <div className="d-flex">
                            <button
                              onClick={handleShowBreakdown(item)}
                              type="button"
                              className="btn btn-black font-weight-bold mr-2"
                            >
                              Breakdown
                            </button>
                            <button
                              type="button"
                              onClick={handleViewSOA(item, applicationId)}
                              className="btn btn-black font-weight-bold mr-2"
                            >
                              View SOA
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

BuildingTransactionsContainer.propTypes = {
  applicationId: PropTypes.string,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionsList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

BuildingTransactionsContainer.defaultProps = {
  applicationId: '',
};

const mapStateToProps = ({ api }) => ({
  transactionsList: _.get(api, `${c.GET_BUILDING_TRANSACTION_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BUILDING_TRANSACTION_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingTransactionsContainer);
